import { BlobResponse } from "nvent-web/services/BlobResponse";
import Resource from "nvent-web/services/resources/Resource";
import type { BlobPart } from "nvent-web/types/BlobPart";

export default class CommissionReportResource extends Resource {
  async download(
    projectId: string,
    projectToken: string,
    fallbackFilename = "commission_report.zip"
  ) {
    const axiosResponse = await this.http.get<BlobPart>(
      `projects/${projectId}/commission_reports`,
      {
        headers: { "Project-Authorization-Token": projectToken },
        responseType: "blob",
        baseURL: import.meta.env.VITE_PUBLIC_API_URL,
      }
    );

    new BlobResponse(axiosResponse).saveAs(fallbackFilename);
  }
}
